import {
    GET_ALL_CONCEPTS_DISCOUNT,
    SAVE_CONCEPT_DISCOUNT,
    CHANGE_VALUE_CONCEPT_DISCOUNT,
    GET_INFO_CONCEPT_DISCOUNT,
    DELETE_CONCEPT_DISCOUNT
 } from '../constants/concepts_discount';
 
 export const concepts_discount = ( state = {}, action ) => {
    switch ( action.type ) { 
 
        case GET_ALL_CONCEPTS_DISCOUNT : {
            return action.payload;
        }

        case SAVE_CONCEPT_DISCOUNT : {
            return action.payload;
        }

        case CHANGE_VALUE_CONCEPT_DISCOUNT : {
            return action.payload;
        }

        case GET_INFO_CONCEPT_DISCOUNT : {
            return action.payload;
        }

        case DELETE_CONCEPT_DISCOUNT : {
            return action.payload;
        }

        default :
        return state;
    }
 }